// extracted by mini-css-extract-plugin
export default {"description":"PersonalInstructionsDialog-module__description--umDgJ","footerContainer":"PersonalInstructionsDialog-module__footerContainer--YsPvr"};